import React from 'react'
import { DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { NameDto } from 'api/Common/Types'
import {
  isCampaignCalculationAccountType,
  isCampaignCalculationTiersType,
} from 'api/Trading-Accounts/Types/CalculationType'
import { CampaignRebateDto } from 'api/Trading-Accounts/Types/MarketingCampaignDetailDto'
import { FormSubmitValues } from 'utils/formValidation'

import { CampaignRebateConfigurationAccountTypeModal } from './CampaignRebateConfigurationAccountTypeModal'
import { CampaignRebateConfigurationTierModal } from './CampaignRebateConfigurationTierModal'

type CampaignDetailsBusinessRuleProps = OuterProps
export type CampaignRebateConfiguration = CampaignRebateDto & { id: string }

interface OuterProps {
  data?: CampaignRebateConfiguration
  rebates: CampaignRebateDto[]
  calculationTypeId: number | undefined
  tradingAccountTypes: NameDto[]
  calculationTypes: NameDto[]
  onSubmit(values?: FormSubmitValues<CampaignRebateConfiguration>): void
}

export const CampaignRebateConfigurationModal: React.FC<CampaignDetailsBusinessRuleProps> = (
  props
) => {
  const { calculationTypeId } = props

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Rebate Configuration</DialogTitle>
      </DialogHeader>

      {isCampaignCalculationTiersType(calculationTypeId) && (
        <CampaignRebateConfigurationTierModal {...props} />
      )}
      {isCampaignCalculationAccountType(calculationTypeId) && (
        <CampaignRebateConfigurationAccountTypeModal {...props} />
      )}
    </DialogContent>
  )
}
